import React, {Component} from "react";
import GSMResultDetails from "./components/GSMResultDetails";
import Sidebar from "./components/Sidebar";
import CustomNavbar from "./components/CustomNavbar";
import ElutionCurve from "./components/ElutionCurve";
import SpectrumViewer from "./components/SpectrumViewer";
import Amplify from 'aws-amplify';
import {Authenticator} from 'aws-amplify-react';
import aws_exports from './aws-exports';
import {fetchProjectsList} from "./actions/ProjectAction";

Amplify.configure(aws_exports);

class App extends Component {

    constructor(props) {
        super(props);

        this.handleAuthStateChange = this.handleAuthStateChange.bind(this);

        this.state = {
            authState: props.authState || null,
            authData: props.authData || null
        };

        this.authConfig = {
            includeGreetings: false,
            authenticatorComponents: [],
            federated: null,
            theme: null,
            signUpConfig: {}
        }
    }

    handleAuthStateChange(state, data) {

        this.setState({authState: state, authData: data});
        if (state === 'signedIn') {
            // this.props.store.dispatch(fetchProject("c8e25fab-7b8d-478d-83ab-385927b6349d"));
            this.props.store.dispatch(fetchProjectsList())
        }
    }

    render() {

        const {authState, authData} = this.state;
        const signedIn = (authState === 'signedIn');
        if (signedIn) {

            const sidebarStyle = {
                boxShadow: "inset -1px 0 0 rgba(0, 0, 0, .1)",
                minWidth: "300px",
                width: "300px"
            };

            return (
                <div className="h-100 d-flex flex-column">
                    <CustomNavbar userName={authData.username}/>
                    <div className="flex-grow-1 d-flex w-100 h-100">
                        <Sidebar className="h-100 bg-light py-3 px-3" style={sidebarStyle}/>
                        <div className="flex-grow-1 flex-row px-3">
                            <h6 className="mt-3">Spectrum</h6>
                            <GSMResultDetails/>
                            <SpectrumViewer className="flex-grow-1"/>
                            <h6 className="mt-3">Spectrum Clusters</h6>
                            <ElutionCurve/>
                        </div>
                    </div>
                </div>
            );
        }

        return <Authenticator
            {...this.props}
            theme={this.authConfig.theme}
            federated={this.authConfig.federated || this.props.federated}
            hideDefault={this.authConfig.authenticatorComponents && this.authConfig.authenticatorComponents.length > 0}
            signUpConfig={this.authConfig.signUpConfig}
            onStateChange={this.handleAuthStateChange}
            children={this.authConfig.authenticatorComponents || []}
        />;
    }
}

export default App;